export * from './ubiProfilePicture.pipe';



// WEBPACK FOOTER //
// C:/Temp/Avemov/Avemov-Angular/src/app/theme/pipes/ubiProfilePicture/index.ts